document.addEventListener( 'DOMContentLoaded', () => {
	document.addEventListener( 'click', ( e ) => {
		const btn = e.target?.closest?.( '.multiple-heading-links__toggle' );
		if ( ! btn ) {
			return;
		}

		const section = btn.closest( '.multiple-heading-links[data-wdg-expandable="1"]' );
		if ( ! section ) {
			return;
		}

		const viewport = section.querySelector( '.multiple-heading-links__viewport' );
		if ( ! viewport ) {
			return;
		}

		viewport.classList.add( 'is-expanded' );
		viewport.classList.remove( 'is-collapsed' );
		btn.classList.add( 'is-hidden' );
	} );
});
